import { GridDiv, OverviewState } from '@types';

export const INITIAL_STATE: OverviewState = {
  chargesInfo: {
    waiverType: null,
    waiverEndDate: null,
  },
  data: {
    fundInformation: null,
    salesCharges: null,
    identifiers: null,
    distributions: null,
    tradingCharacteristics: null,
    temitKeyDateDetails: null,
  },
  gridDiv: GridDiv.ONE,
  siteConfig: null,
};
